import React from "react"
import PropTypes from "prop-types"

const DocumentIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 21 26">
    <g transform="translate(-26.000000, -177.000000)">
      <path d="M26,177 L26,203 L39.3595639,203 L47,195.070321 L47,177 L26,177 Z M28.3344394,179.408691 L44.6655606,179.408691 L44.6655606,194.076543 L38.3789998,200.591309 L28.3344394,200.591309 L28.3344394,179.408691 Z M31.5996682,184.703704 L41.4003318,184.703704 L41.4003318,182.29758 L31.5996682,182.29758 L31.5996682,184.703704 Z M31.5996682,189.035753 L41.4003318,189.035753 L41.4003318,186.62963 L31.5996682,186.62963 L31.5996682,189.035753 Z M35.8006637,191.444444 L35.8006637,198.667951 L38.1326144,198.667951 L38.1326144,193.853136 L42.7990045,193.853136 L42.7990045,191.444444 L35.8006637,191.444444 Z"></path>
    </g>
  </svg>
)

DocumentIcon.propTypes = {
  style: PropTypes.object
}

export default DocumentIcon



// WEBPACK FOOTER //
// ./src/components/icons/document-icon.jsx